<template>
  <div class="inputer" :class="{'not-valid': !valid}">
    <textarea
      :value="value"
      @input="change"
      @keypress.enter="enter"
      :placeholder="name"
      :disabled="disabled"
      :rows="lineCount"
      :id="id"
    ></textarea>
    <div v-if="changed" class="changed" title="Neuložená změna">
      <i class="fa fa-wrench" />
    </div>
  </div>
</template>

<script>
export default {
  name: "inputer",
  props: {
    id: { default: null },
    name: { default: "" },
    paths: {},
    disabled: { default: false },
    required: { default: false },
    lineCount: { default: 1 },
    onMultiInsert: { default: null }
  },
  computed: {
    value() {
      return this.$store.getters.getAt(this.paths);
    },
    changed() {
      return this.$store.getters.isChangedAt(this.paths);
    },
    valid() {
      return this.$store.getters.isValidAt(this.paths);
    }
  },
  methods: {
    change(event) {
      var value = event.target.value;

      // multiple items
      if (value != null && value.length > 0) {
        var items = value.split(/\n/).filter(i => i != null && i.length > 0);
        if (
          this.onMultiInsert != null &&
          (items.length > 1 || items[0].split("\t").length > 1)
        ) {
          this.onMultiInsert(items);
          return;
        }
      }
      
      if (value === "")
        value = null;

      this.$store.commit("update", {
        paths: this.paths,
        value: value
      });
    },
    enter(event) {
      if (this.lineCount == 1)
        event.preventDefault();
    }
  },
  mounted() {
    // validation
    if (!this.required) return;

    this.$store.commit("addEventHandler", {
      paths: this.paths,
      id: 'e9af799c-0d67-43d5-ba4f-63d4ea9c0574',
      action: function (type) {
        if (type == "remove") {
          if (!this.valid) {
            this.$store.commit("removeValidationError", {
              paths: this.paths
            });
          }

          return;
        }

        if (this.value != null && this.value.length > 0) {
          if (!this.valid) {
            this.$store.commit("removeValidationError", {
              paths: this.paths
            });
          }
        } else {
          this.$store.commit("addValidationError", {
            paths: this.paths,
            message: `Pole '${this.name}' je povinné`
          });
        }
      }.bind(this)
    });

    // validate now
    if (this.value == null || this.value.length == 0) {
      this.$store.commit("addValidationError", {
        paths: this.paths,
        message: `Pole '${this.name}' je povinné`
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.inputer
  @include inputer()
</style>
